import styled from "styled-components";
import { buildColor } from "@tvg/design-system";

export const DynamicSelectorWrapper = styled.div`
  width: 100%;
  background: ${buildColor("blue_accent", "000")};
  border-bottom: 1px solid ${buildColor("blue", "100")};
  height: 49px;
  overflow: auto;
`;

export const SelectionsWrapper = styled.div`
  width: fit-content;
  background: ${buildColor("blue_accent", "000")};
  div {
    background: ${buildColor("blue_accent", "000")};
  }
`;
